import { ReactNode, useCallback } from "react";

import CardCollapsible from "ds/components/Card/Collapsible";
import Link from "ds/components/Link";
import Typography from "ds/components/Typography";
import useAnalytics from "hooks/useAnalytics";
import { AnalyticsPageLaunchpad } from "hooks/useAnalytics/pages/launchpad";
import { useToggle } from "hooks/useToggle";

import { showLaunchPadFAQDrawer } from "./Drawer";

type LaunchPadFAQItemProps = {
  title: string;
  children: ReactNode;
  learnMoreContent?: ReactNode;
  learnMoreTitle?: string;
};

const LaunchPadFAQItem = ({
  title,
  children,
  learnMoreContent,
  learnMoreTitle,
}: LaunchPadFAQItemProps) => {
  const trackSegmentAnalyticsEvent = useAnalytics({
    page: AnalyticsPageLaunchpad.Launchpad,
  });

  const [isCollapsed, onToggle] = useToggle(true);

  const handleToggle = useCallback(() => {
    if (isCollapsed) {
      trackSegmentAnalyticsEvent("FAQ Question Click", { title });
    }

    onToggle();
  }, [isCollapsed, onToggle, title, trackSegmentAnalyticsEvent]);

  const showDrawer = () => {
    if (!learnMoreContent || !learnMoreTitle) {
      return;
    }

    showLaunchPadFAQDrawer({
      title: learnMoreTitle,
      content: learnMoreContent,
    });
  };

  return (
    <CardCollapsible
      title={title}
      isCollapsed={isCollapsed}
      onToggle={handleToggle}
      ariaLevel={3}
      ariaLabel={title}
    >
      <Typography tag="p" variant="p-body3">
        {children}{" "}
        {learnMoreContent && learnMoreTitle && (
          <Link size="small" onPress={showDrawer}>
            Read More
          </Link>
        )}
      </Typography>
    </CardCollapsible>
  );
};

export default LaunchPadFAQItem;
